import { AuthService } from 'src/app/auth/guards/auth-service.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../services/api-service/apiService/api.service';
import { FIELDS_TABLE_TRANSACTION } from '../model/mocks/mock-fieldsTableTransaction';
import { NumberFormatService } from '../services/numberFormat/number-format-service.service';
//
interface TypeTransaction {
  id: number;
  name: string;
  created_at: string;
}

interface Currency {
  id: number;
  name: string;
  symbol: string;
  created_at: string;
}

interface Pair {
  id: number;
  name: string;
  currencyOrigin: Currency;
  currencyDestiny: Currency;
  created_at: string;
}

interface User {
  id: number;
  name: string;
  email: string;
  rol: {
    id: number;
    acronym: string;
    name: string;
    permissions: string;
  };
  created_at: string;
}

interface PointOfSell {
  id: number;
  name: string;
  user: User;
  created_at: string;
}

interface Customer {
  id: number;
  name: string;
  created_at: string;
}

interface Transaction {
  id: number;
  type_transaction: TypeTransaction;
  pair: Pair;
  quantity: number;
  price: number;
  mount: number;
  status: string;
  point_of_sell: PointOfSell;
  customer: Customer;
  date: string;
}

interface TransactionResponse {
  current_page: number;
  data: Transaction[];
  total: number;
  per_page: number;
}

@Component({
  selector: 'app-history-transaction',
  templateUrl: './history-transaction.component.html',
  styleUrls: ['./history-transaction.component.css'],
  providers: [ConfirmationService, MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryTransactionComponent implements OnInit {
  transactions: Transaction[] = [];
  totalRecords: number = 0;
  rowsPerPage: number = 50;
  loading: boolean = true;
  first: number = 0;

  fieldsTableTransactions = FIELDS_TABLE_TRANSACTION;
  calendarIcon = 'pi pi-calendar';
  filteredData: Transaction[] = [];
  isFilter = false;
  rangeDates: Date[] | undefined;
  dateTime = new Date();

  role!: any;
  userID!: any;
  displayDelete!: boolean;
  user: any;
  canEdit: any;
  selectedTransaction: Transaction | null = null;

  table: { name: string, buy: number, sell: number }[] = [];

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private numberFormatService: NumberFormatService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.role = this.authService.userRole;
    this.userID = parseInt(this.authService.userId);
    this.user = this.authService.getCurrentUser();
    if (this.user?.permissions?.['transacciones']) {
      this.canEdit = this.user.permissions['transacciones'].includes('historial_editar') || this.role == 'Administrador';
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const pageParam = parseInt(params['page'], 10);
      const page = !isNaN(pageParam) && pageParam > 0 ? pageParam : 1;
      this.first = (page - 1) * this.rowsPerPage;
      this.loadTransactions(page);
    });
    this.getTransactionDetails();
  }

  getTransaction() {
    if (this.role == 'Cajero') {
      this.apiService.getById(ApiService.apiURLBack + 'transacciones', this.userID).subscribe({
        next: (response: any) => {
          this.transactions = response;
          if (this.transactions.length === 0) {
            this.messageService.add({
              severity: 'info',
              summary: 'No posee transacciones',
              sticky: true,
            });
          }
          this.cdr.detectChanges();
        },
        error: (error: { message: any }) => {
          this.messageService.add({
            severity: 'error',
            summary: error.message,
            life: 2000,
          });
        },
      });
      return;
    }
    else {
      this.apiService.get(ApiService.apiURLBack + 'transaccion').subscribe({
        next: (response: any) => {
          this.transactions = response;
          console.log(response);
          this.cdr.detectChanges();
        },
        error: (error: { message: any }) => {
          this.messageService.add({
            severity: 'error',
            summary: error.message,
            life: 2000,
          });
        },
      });
    }
  }

  loadTransactions(page: number = 1, perPage: number = this.rowsPerPage): void {
    this.loading = true;
    const urlBase = this.role === 'Cajero'
      ? `${ApiService.apiURLBack}transacciones`
      : `${ApiService.apiURLBack}transaccion`;

    const url = `${urlBase}?page=${page}&per_page=${perPage}${this.role === 'Cajero' ? `&user_id=${this.userID}` : ''}`;

    this.apiService.get(url).subscribe({
      next: (response: TransactionResponse) => {
        this.transactions = response.data;
        this.totalRecords = response.total;

        this.rowsPerPage = response.per_page;


        this.loading = false;
        this.cdr.detectChanges();

        if (this.transactions.length === 0 && this.role === 'Cajero') {
          this.messageService.add({
            severity: 'info',
            summary: 'No posee transacciones',
            sticky: true,
          });
        }
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error al cargar las transacciones',
          detail: error.message,
          life: 2000,
        });
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  getTransactionDetails() {
    this.apiService.get(ApiService.apiURLBack + 'transaccionesDetalladas').subscribe({
      next: (response: any[]) => {
        this.table = response;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: error.message,
          life: 2000,
        });
      }
    });
  }

applyDateFilter() {
  if (this.rangeDates && this.rangeDates.length === 2) {
    this.isFilter = true;

    // Normalizamos los rangos de fecha para cubrir todo el día
    const startDate = new Date(this.rangeDates[0]);
    const endDate = new Date(this.rangeDates[1]);

    startDate.setHours(0, 0, 0, 0); // inicio del día
    endDate.setHours(23, 59, 59, 999); // fin del día

    this.filteredData = this.transactions.filter((item, index) => {
      const rawDate = item.date;
      const fixedDateStr = rawDate.replace(' ', 'T'); // corregimos el formato
      const itemDate = new Date(fixedDateStr);

      const isValid = !isNaN(itemDate.getTime());
      const isInRange = isValid && itemDate >= startDate && itemDate <= endDate;

      return isInRange;
    });

  } else {
    this.filteredData = this.transactions;
    this.isFilter = false;
  }
}

  clearFilter() {
    this.isFilter = false;
    this.rangeDates = undefined;
    this.filteredData = this.transactions;
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.rowsPerPage = event.rows;
    const pageNumber = Math.floor(this.first / this.rowsPerPage) + 1;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: pageNumber },
      queryParamsHandling: 'merge',
    });

    this.loadTransactions(pageNumber, this.rowsPerPage);
  }

  deletetransaction(transactionAUX: any) {
    this.confirmationService.confirm({
      message: 'Deseas eliminar esta transacción?',
      header: 'Confirmar operación',
      icon: 'pi pi-info-circle',
      accept: () => {
        const transactionToDelete = this.transactions.find(t => t.id === transactionAUX.id);
        if (transactionToDelete) {
          const index = this.transactions.indexOf(transactionToDelete);
          if (index !== -1) {
            this.transactions.splice(index, 1);
            this.cdr.detectChanges();

            this.apiService.delete(ApiService.apiURLBack + 'transaccion', transactionAUX.id).subscribe(
              () => {
                this.messageService.add({
                  severity: 'info',
                  summary: 'Confirmado',
                  detail: 'Registro eliminado',
                });
                this.loadTransactions();
              },
              (error) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Error al eliminar el registro',
                });
              }
            );
          }
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Transacción no encontrada',
            detail: 'No se encontró la transacción a eliminar',
          });
        }
      },
      reject: () => {
      }
    });
  }

  onConfirmDelete() {
    if (this.selectedTransaction) {
      this.apiService.delete(ApiService.apiURLBack + 'transaccion', this.selectedTransaction.id).subscribe(
        () => {
          this.messageService.add({
            severity: 'info',
            summary: 'Confirmado',
            detail: 'Registro eliminado',
          });
          this.loadTransactions();
          this.selectedTransaction = null;
          this.displayDelete = false;
        },
        () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al eliminar el registro',
          });
          this.selectedTransaction = null;
          this.displayDelete = false;
        }
      );
    }
  }

  onRejectDelete() {
    this.selectedTransaction = null;
    this.displayDelete = false;
  }

  formatDateOfViuwToString(dateString: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
  }

  formatHourOfTransaction(dateString: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  }

  formatNumber(value: number): string {
    return this.numberFormatService.formatNumber(value);
  }
}
